import React, { useRef, useImperativeHandle, forwardRef } from 'react';
// import { Image } from "react-bootstrap";
import withZoomViewer from './withZoomViewer';
import { Image } from 'antd';
import type { Annotation as AnnotationType, Dimension } from '../features/annotation';

const ImageWithZoom = withZoomViewer(Image);

interface WithAnnotationProps {
  annotations: any[];
  setAnnotations: (annotations: AnnotationType[]) => void;
  selectAnnotation: (id: number | null) => void;
  handleUploadDamages: () => void; // fixed typo
  imageFrame: Dimension;
  user: any;
  image1: string;
  [key: string]: any; // allow extra props
}

const withAnnotation = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const HOC = forwardRef<any, P & WithAnnotationProps>((props, ref) => {
    const childRef = useRef<any>(null);

    const {
      annotations,
      setAnnotations,
      selectAnnotation,
      handleUploadDamages, // fixed typo
      user,
      image1,
      imageFrame,
      ...rest
    } = props;
    // const Controls = props.zoomControls;

    // Expose methods to parent
    useImperativeHandle(ref, () => ({
      // save: handleSaveClick,
      triggerSaveMethod: () => childRef.current?.triggerSaveMethod(),
      triggerSubmitMethod: () => childRef.current?.triggerSubmitMethod(),

      clear: handleClearClick,
      triggerDamageMethod: (data: any) => childRef.current?.triggerDamageMethod?.(data),
    }));

    // Core Handlers
    function handleSaveClick() {
      selectAnnotation(null);
      childRef.current?.triggerSaveMethod?.();
    }

    function handleSubmitClick() {
      childRef.current?.triggerSubmitMethod?.();
    }

    function handleClearClick() {
      childRef.current?.triggerClearMethod?.();
      selectAnnotation(null);
    }

    function handleDamageChange(e: any) {
      childRef.current?.triggerDamageMethod?.(e);
    }

    return (
      <div className="h-full w-full">
        <ImageWithZoom
          zoomControls={props.zoomControls}
          isAddAnnotation={props.isAddAnnotation}
          src={props.item.src}
          preview={false}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            cursor: 'pointer',
          }}
          // loading="lazy"
        >
          <WrappedComponent
            ref={childRef}
            image1={image1}
            imageFrame={imageFrame}
            {...(rest as P)}
            annotations={annotations}
            setAnnotations={setAnnotations}
            selectAnnotation={selectAnnotation}
            handleSaveClick={handleSaveClick}
            handleSubmitClick={handleSubmitClick}
            handleClearClick={handleClearClick}
            handleDamageChange={handleDamageChange}
            handleUploadDamages={handleUploadDamages}
            user={user}
          />
        </ImageWithZoom>
      </div>
    );
  });

  return HOC;
};

export default withAnnotation;
